import { SchedulerSidebarCrewChangeScope } from '@contexts/scheduler/sidebar/types';
import { CurrentSchedule, RelatedMultischedule } from '@services/schedules/internal/types';
import { formatTime, shortDayDate } from '@utils/i18n';
import { isBefore, parseISO } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import { DayChangeStatus } from './types';

export const MAX_DAYS_WITHOUT_TABS = 7;

export const getDayChangeStatus = ({
  schedule,
  currentSchedule,
  crewChangeScope,
  zone,
}: {
  schedule: RelatedMultischedule;
  currentSchedule: CurrentSchedule;
  crewChangeScope: SchedulerSidebarCrewChangeScope;
  zone: string;
}): DayChangeStatus => {
  const { id, sameForeman, sameCrew, completed } = schedule;
  if (id === currentSchedule.id) return { affected: true, current: true };
  if (completed) return { affected: false, reason: 'completed' };
  if (!sameForeman && !sameCrew) return { affected: false, reason: 'differentCrewAndForeman' };
  if (!sameCrew) return { affected: false, reason: 'differentCrew' };
  if (!sameForeman) return { affected: false, reason: 'differentForeman' };
  if (crewChangeScope === 'currentOnly') return { affected: false, reason: 'notSelected' };
  if (
    crewChangeScope === 'currentAndFuture' &&
    isBefore(
      toZonedTime(parseISO(schedule.startsAt), zone),
      toZonedTime(parseISO(currentSchedule.startsAt), zone),
    )
  )
    return { affected: false, reason: 'earlierDay' };
  return { affected: true };
};

export const checkScheduleDisabled = (params: Parameters<typeof getDayChangeStatus>[0]) =>
  !getDayChangeStatus(params).affected;

export const getScheduleDisplayDate = (startsAt: string, endsAt: string, zone: string) => {
  const start = toZonedTime(parseISO(startsAt), zone);
  const end = toZonedTime(parseISO(endsAt), zone);
  return `${shortDayDate(start)} | ${formatTime(start)} - ${formatTime(end)}`;
};

export const getCurrentWeek = (weeks: Record<string, RelatedMultischedule[]>) =>
  Object.keys(weeks).find((week) => weeks[week].some((el) => el.currentSchedule)) ||
  Object.keys(weeks)[0];
